module.exports = __webpack_public_path__ + "static/img/voice-room-bg.142141b7.png";